/* eslint-disable array-callback-return */
import { Box, Dialog, DialogContent, DialogTitle, Grid } from "@material-ui/core"
import { ChangeEvent, useContext, useState } from "react"
import {  IconButton } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";
import "../css/Kardex.css"
import TrainingContext from "../../../context/FormacionDesarollo/TrainingContext";
import { closeKardex } from "../../../context/FormacionDesarollo/TrainingActions";
import TableKardexInfo from "../components/TableKardexInfo";
import { GET_KARDEXPLANS_INFO, GET_USERKARDEXPLANS_INFO, GET_USERKARDEXCURSOS_INFO } from "../../../Querys/querys";
import { useQuery } from "@apollo/client";
import { makeStyles } from '@material-ui/core/styles'
import FormatDateIngreso from "../components/FormatDateIngreso";
import CustomTabs from "../../Collaborators/Tab/CustomTabs";
import CustomTab from "../../Collaborators/Tab/CustomTabMain";
import AvatarImage from "../components/AvatarImage";
import TableKardexInfoCursos from "../components/TableKardexInfoCursos";
import {trainingPlans, courses } from "../components/DummyData"

const useStyles = makeStyles((theme) => ({
    dialogPaper: {
      minWidth: '400px',
      maxWidth: '1450px',  
    },  
    wideContent: {
      minWidth: '100%',    
    },  
  }));

const Kardex = (props: any)=>{
    const {state, dispatch} = useContext(TrainingContext)
    // const [trainingKardex, setTrainingKardex] = useState([]);
    // const [coursesKardex, setCoursesKardex] = useState([]);
    const [trainingKardex, setTrainingKardex] = useState(trainingPlans);
    const [coursesKardex, setCoursesKardex] = useState(courses);
    const [selected, setSelected] = useState<readonly number[]>([]);
    const [arrayCompetenceEvaluation, setArrayCompetenceEvaluation] = useState([])
    const [page, setPage] = useState(0)
    const [pageC, setPageC] = useState(0)
    const [tab, setTab] = useState(0);
    const classes = useStyles();
    // const { data, startPolling: startPollingPlans, stopPolling: stopPollingPlans, loading: loadingPlans  } = useQuery(GET_KARDEXPLANS_INFO, {
    //     variables: {
    //         id: state._id
    //     },
    //     fetchPolicy: 'no-cache'
    // });
    // const allPlansInfo = data?.GET_KARDEXPLANS_INFO || [];
    const { data: info, loading: loadingUser } = useQuery(GET_USERKARDEXPLANS_INFO, {
        variables: {
            id: state._id
        },
        fetchPolicy: 'no-cache'
    });
    const allUserInfo = info?.GET_USERKARDEXPLANS_INFO || [];
    // const { data: infoCourses, startPolling: startPollingCursos, stopPolling: stopPollingCursos, loading: loadingCursos } = useQuery(GET_USERKARDEXCURSOS_INFO, {
    //     variables: {
    //         id: state._id
    //     },
    //     fetchPolicy: 'no-cache'
    // });
    // const allCoursesInfo = infoCourses?.GET_USERKARDEXCURSOS_INFO || [];

    // useEffect(() => {
    //   startPollingPlans(4000);
    //   return () =>{
    //     stopPollingPlans()
    //   }
    // }, [allPlansInfo,startPollingPlans, stopPollingPlans]); 

    // useEffect(() => {
    //   startPollingCursos(4000);
    //   return () =>{
    //     stopPollingCursos()
    //   }
    // }, [allCoursesInfo,startPollingCursos, stopPollingCursos]); 

    // useEffect(() => {
    //     if(infoCourses?.GET_USERKARDEXCURSOS_INFO){
    //         if (allCoursesInfo.length > 0 ) {
    //             setCoursesKardex(allCoursesInfo) 
    //         }
    //     }
    // }, [allCoursesInfo, infoCourses?.GET_USERKARDEXCURSOS_INFO]); 

    // useEffect(() => {
    //     if(data?.GET_KARDEXPLANS_INFO){
    //         if (allPlansInfo.length > 0 ) {
    //             setTrainingKardex(allPlansInfo)
    //         }
    //     }
    //   }, [allPlansInfo, data?.GET_KARDEXPLANS_INFO]); 

      const handleChange = (event: ChangeEvent<{}>, newValue: number) => {
        setTab(newValue);
        localStorage.setItem("currentPill", String(newValue));
      };

    const closeModalKardex = () => {
        closeKardex(false, dispatch)
        // setTrainingKardex([])
        // setCoursesKardex([])
        setTab(0)
    }

    return (
      <>
      {/* {(loadingPlans === true && loadingCursos === true && loadingUser === true) ? <></> 
      : <> */}
      <Dialog
        open={state.openModalKardex}
        aria-labelledby="form-dialog-title"
        className="dialogCurso"
        fullWidth={true}
        classes={{ paper: classes.dialogPaper }}
      >
        <IconButton
          aria-label="close"
          onClick={() => {
            closeModalKardex();
          }}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent>
          <DialogContent style={{ display: "flex", paddingBottom: "40px" }}>
            <div className="avatar">
              <AvatarImage
                image={allUserInfo[0]?.ImagenUsuario}
                abrv={allUserInfo[0]?.abrvName}
              />
            </div>
            <div>
              <DialogTitle>
                <span className="titleKardexM">Cursos y capacitaciones</span>
              </DialogTitle>

              <DialogContent
                className="UsuarioInfo"
                style={{ paddingBottom: 0 }}
              >
                <div className="infoGroup">
                  <div className="userInfoContainer">
                    <div>
                      <span className="userInfo" style={{ minWidth: "170px", maxWidth: "300px" }}>
                        {allUserInfo[0]?.bussinesName}
                      </span>
                    </div>
                    <div>
                      <span
                        className="userInfoOpacity"
                        style={{ minWidth: "170px", maxWidth: "300px" }}
                      >
                        {allUserInfo[0]?.email}
                      </span>
                    </div>
                  </div>
                  <div className="verticalLine"></div>
                  <div className="userInfoContainer">
                    <div>
                      <span className="userInfo" style={{ minWidth: "50px", maxWidth: '250px' }}>
                        Sede
                      </span>
                    </div>
                    <div>
                      <span
                        className="userInfoOpacity"
                        style={{ minWidth: "50px", maxWidth: '250px' }}
                      >
                        {allUserInfo[0]?.campus}
                      </span>
                    </div>
                  </div>
                  <div className="verticalLine"></div>
                  <div className="userInfoContainer">
                    <div>
                      <span className="userInfo" style={{ minWidth: "60px", maxWidth: '280px' }}>
                        Puesto
                      </span>
                    </div>
                    <div>
                      <span
                        className="userInfoOpacity"
                        style={{ minWidth: "60px", maxWidth: '280px' }}
                      >
                        {allUserInfo[0]?.puesto}
                      </span>
                    </div>
                  </div>
                  <div className="verticalLine"></div>
                  <div className="userInfoContainer">
                    <div>
                      <span className="userInfo" style={{ width: "150px" }}>
                        Fecha de ingreso
                      </span>
                    </div>
                    <div>
                      <span
                        className="userInfoOpacity"
                        style={{ width: "150px" }}
                      >
                        <FormatDateIngreso
                          dateOfAdmission={allUserInfo[0]?.dateOfAdmission}
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </DialogContent>
            </div>
          </DialogContent>

          <Box p={5} pb={3} pt={0}>
            <Grid
              container
              justify="flex-start"
              alignItems="center"
              spacing={2}
            >
              <div className="containerBtnsPrincipal">
                <CustomTabs
                  value={tab}
                  onChange={handleChange}
                  aria-label="simple tabs example"
                >
                  <CustomTab label="Planes de capacitación" value={0} />
                  <CustomTab label="Cursos" value={1} />
                </CustomTabs>
                <div style={{ display: "flex" }}>
                  <div>
                    {tab === 0 ? (
                        <>
                            <span className="terminatedText" style={{ display: "flex", justifyContent: 'center' }}>Terminados</span>
                            <span className="numberTerminated">{trainingKardex[0] ? 6 : 0}</span>
                            {/* <span className="numberTerminated">{allPlansInfo[0]?.terminatedPlans ? allPlansInfo[0]?.terminatedPlans : 0}</span> */}
                        </>
                    ) : (
                        <>
                            <span className="terminatedText" style={{ display: "flex", justifyContent: 'center' }}>Terminados</span>
                            <span className="numberTerminated">{coursesKardex[0] ? 4 : 0}</span>
                            {/* <span className="numberTerminated">{allCoursesInfo[0]?.terminatedCourses ? allCoursesInfo[0]?.terminatedCourses : 0}</span> */}
                        </>
                    )}
                  </div>
                  <div className="verticalLineInfo"></div>
                  <div>
                    {tab === 0 ? (
                        <>
                            <span className="terminatedText" style={{ display: "flex", justifyContent: 'center' }}>En curso</span>
                            <span className="numberTerminated">{trainingKardex[0] ? 5 : 0}</span>
                            {/* <span className="numberTerminated2">{allPlansInfo[0]?.inProgressPlans ? allPlansInfo[0]?.inProgressPlans : 0}</span> */}
                        </>
                ) : (
                        <>
                            <span className="terminatedText" style={{ display: "flex", justifyContent: 'center' }}>En curso</span>
                            <span className="numberTerminated">{coursesKardex[0] ? 7: 0}</span>
                            {/* <span className="numberTerminated2">{allCoursesInfo[0]?.inProgressCourses ? allCoursesInfo[0]?.inProgressCourses : 0}</span> */}
                        </>
                )}
                  </div>
                </div>
              </div>
            </Grid>
          </Box>
          <div className="contenedorInfoPlanes">
            {tab === 0 && (
                trainingKardex.length > 0 ? (
                    <TableKardexInfo
                        rows={trainingKardex}
                        setArrayIncident={setArrayCompetenceEvaluation}
                        selected={selected}
                        setSelected={setSelected}
                        page={page}
                        setPage={setPage}
                    />
            ) : (
                <p className="msjNotFoundKardex">No tienes planes de capacitación asignados</p>
            )
            )}
            {tab === 1 && (
                coursesKardex.length > 0 ? (
                <TableKardexInfoCursos
                rows={coursesKardex}
                setArrayIncident={setArrayCompetenceEvaluation}
                selected={selected}
                setSelected={setSelected}
                page={pageC}
                setPage={setPageC}
              />
            ) : (
                <p className="msjNotFoundKardex">No tienes cursos asignados</p>
            )
            )}
          </div>
          <DialogContent className="twoBtnsCurso">
            <div className="containerButtons">
              <div className="containerCancelCurso">
                <button
                  className="btnCancelarKardex"
                  type="button"
                  onClick={() => {
                    closeModalKardex();
                  }}
                >
                  Cerrar
                </button>
              </div>
            </div>
          </DialogContent>
        </DialogContent>
      </Dialog>
      </>
      // }
      // </>
    );
}

export default Kardex;